import React from 'react';
export function BonusSection() {
  return <section className="py-16 px-6 bg-white" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <div className="text-center mb-10" data-id="element-20">
          <p className="text-blue-600 font-semibold uppercase tracking-widest text-sm mb-2" data-id="element-21">
            Incluidos en todas las ofertas — sin costo extra
          </p>
          <h2 className="text-3xl font-extrabold text-gray-900" data-id="element-22">
            Más los 6 Regalos Estratégicos
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-23">
          {[{
          num: '01',
          title: 'Generador de Informes Pedagógicos',
          desc: 'Banco de frases por nivel y semáforo (verde/amarillo/rojo) para redactar 30 informes trimestrales en menos de 40 minutos.',
          value: '$4.990'
        }, {
          num: '02',
          title: 'El Organizador Digital de Recursos',
          desc: 'Sistema para ordenar videos, juegos, canciones y sitios web por nivel. Encontrás cualquier recurso en 30 segundos.',
          value: '$4.990'
        }, {
          num: '03',
          title: 'Planilla Maestra de Notas',
          desc: 'Google Sheets con fórmulas automáticas que calcula promedios y detecta alumnos en riesgo antes de que sea tarde.',
          value: '$6.990'
        }, {
          num: '04',
          title: 'Pack de Seguimiento de Alumnos',
          desc: 'Fichas individuales, semáforo grupal semanal y radar de alerta temprana para detectar quién necesita ayuda de un vistazo.',
          value: '$5.990'
        }, {
          num: '05',
          title: 'Plantillas de Recuperatorios',
          desc: 'Plantilla universal + banco de ejercicios por nivel + rúbrica de corrección. Armás un recuperatorio en 5 minutos.',
          value: '$5.990'
        }, {
          num: '06',
          title: 'Organizador Semanal Docente',
          desc: 'Planificador semanal, daily checklist y cierre de viernes para ordenar toda la semana en 20 minutos el domingo.',
          value: '$4.990'
        }].map(b => <div key={b.num} className="border border-gray-200 rounded-2xl p-5 relative hover:shadow-md transition" data-id="element-24">
              <div className="absolute -top-3 left-5 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-25">
                BONUS {b.num}
              </div>
              <div className="mt-2" data-id="element-26">
                <p className="font-bold text-gray-900 text-sm mb-1" data-id="element-27">
                  {b.title}
                </p>
                <p className="text-gray-500 text-xs mb-3" data-id="element-28">{b.desc}</p>
                <div className="flex items-center gap-2" data-id="element-29">
                  <span className="line-through text-gray-400 text-xs" data-id="element-30">
                    Valor {b.value}
                  </span>
                  <span className="bg-green-100 text-green-700 text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-31">
                    → GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}